{
  "de": {
    "pageTitle": "Vinyl-Suche",
    "pageSubtitle": "Schallplatten, LPs, Singles & mehr – direkt durchsuchen",
    "searchPlaceholder": "Titel, Artist, Trackliste ...",
    "exampleLabel": "z.B.:",
    "statsNoResults": "Keine Treffer",
    "statsOneResult": "1 Treffer",
    "statsManyResults": "{n} Treffer",
    "statsTiming": "in {ms}ms",
    "noResultsText": "Keine Treffer für \"{q}\". Versuch einen anderen Suchbegriff.",
    "loadMoreButton": "Mehr laden",
    "filterToggleButton": "Filter",
    "filterFormat": "Format",
    "filterCoverGrade": "Cover-Zustand",
    "filterVinylGrade": "Vinyl-Zustand",
    "filterGenre": "Genre",
    "filterPrice": "Preis",
    "filterPriceAll": "Alle Preise",
    "filterPriceUpTo5": "bis 5 EUR",
    "filterPrice5to15": "5 – 15 EUR",
    "filterPrice15to30": "15 – 30 EUR",
    "filterPrice30to50": "30 – 50 EUR",
    "filterPrice50to100": "50 – 100 EUR",
    "filterPriceOver100": "über 100 EUR",
    "sortRelevance": "Relevanz",
    "sortArtistAsc": "A – Z (Artist)",
    "sortPriceAsc": "Niedrigster Preis",
    "sortPriceDesc": "Höchster Preis",
    "refinementFormat": "Format",
    "refinementCover": "Cover",
    "refinementVinyl": "Vinyl",
    "refinementGenre": "Genre",
    "refinementStyle": "Stil",
    "styleSearchPlaceholder": "Stil suchen …",
    "refinementPrice": "Preis",
    "fieldSku": "SKU",
    "fieldPrice": "Preis",
    "selectButton": "Auswählen",
    "showMore": "mehr anzeigen",
    "showLess": "weniger",
    "browsePlaceholder": "Gib einen Suchbegriff ein oder wähle einen Filter.",
    "formatLabels": {
      "vinyl_single_7": "7\" Single",
      "vinyl_lp": "LP",
      "vinyl_lp_2": "Doppel-LP",
      "vinyl_maxi_12": "Maxi 12\"",
      "vinyl_2x12": "2× 12\"",
      "vinyl_maxi_7": "7\" Maxi",
      "schellack": "Schellack",
      "cd": "CD",
      "cd_maxi": "CD Maxi",
      "cd_box": "CD Box",
      "dvd": "DVD",
      "kassette": "Kassette",
      "laserdisc": "LaserDisc",
      "hoerbuch": "Hörbuch / Hörspiel",
      "hoerbuch_2": "Hörbuch / Hörspiel (2×)",
      "box": "Box",
      "box_5kg": "Box (bis 5 kg)",
      "vinyl_box": "Box-Set",
      "sonstige": "Sonstige",
      "other": "Sonstige",
      "vhs": "VHS",
      "blu_ray": "Blu-ray"
    }
  },
  "en": {
    "pageTitle": "Vinyl Search",
    "pageSubtitle": "Records, LPs, Singles & more – search directly",
    "searchPlaceholder": "Title, artist, tracklist ...",
    "exampleLabel": "e.g.:",
    "statsNoResults": "No results",
    "statsOneResult": "1 result",
    "statsManyResults": "{n} results",
    "statsTiming": "in {ms}ms",
    "noResultsText": "No results for \"{q}\". Try a different search term.",
    "loadMoreButton": "Load more",
    "filterToggleButton": "Filter",
    "filterFormat": "Format",
    "filterCoverGrade": "Cover Condition",
    "filterVinylGrade": "Vinyl Condition",
    "filterGenre": "Genre",
    "filterPrice": "Price",
    "filterPriceAll": "All prices",
    "filterPriceUpTo5": "up to EUR 5",
    "filterPrice5to15": "EUR 5 – 15",
    "filterPrice15to30": "EUR 15 – 30",
    "filterPrice30to50": "EUR 30 – 50",
    "filterPrice50to100": "EUR 50 – 100",
    "filterPriceOver100": "EUR 100+",
    "sortRelevance": "Relevance",
    "sortArtistAsc": "A – Z (Artist)",
    "sortPriceAsc": "Lowest price",
    "sortPriceDesc": "Highest price",
    "refinementFormat": "Format",
    "refinementCover": "Cover",
    "refinementVinyl": "Vinyl",
    "refinementGenre": "Genre",
    "refinementStyle": "Style",
    "styleSearchPlaceholder": "Search style …",
    "refinementPrice": "Price",
    "fieldSku": "SKU",
    "fieldPrice": "Price",
    "selectButton": "Select",
    "showMore": "show more",
    "showLess": "show less",
    "browsePlaceholder": "Enter a search term or select a filter.",
    "formatLabels": {
      "vinyl_single_7": "7\" Single",
      "vinyl_lp": "LP",
      "vinyl_lp_2": "Double LP",
      "vinyl_maxi_12": "12\" Maxi",
      "vinyl_2x12": "2× 12\"",
      "vinyl_maxi_7": "7\" Maxi",
      "schellack": "Shellac",
      "cd": "CD",
      "cd_maxi": "CD Maxi",
      "cd_box": "CD Box",
      "dvd": "DVD",
      "kassette": "Cassette",
      "laserdisc": "LaserDisc",
      "hoerbuch": "Audiobook / Radio Play",
      "hoerbuch_2": "Audiobook / Radio Play (2×)",
      "box": "Box",
      "box_5kg": "Box (up to 5 kg)",
      "vinyl_box": "Box Set",
      "sonstige": "Other",
      "other": "Other",
      "vhs": "VHS",
      "blu_ray": "Blu-ray"
    }
  }
}
